import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  count: PropTypes.number,
};

const CountBadge = (props) => {
  return (
    <>
      <strong>
        <span className="badge rounded-pill hold count">{props.count}</span>
      </strong>
    </>
  );
};

CountBadge.propTypes = propTypes;

export default CountBadge;
